/* Länderliste für das Feld "Nationality" — reine Daten und Funktionen, kein DOM.
 *
 * Gespeichert wird weiterhin der ENGLISCHE Ländername als Text (player.nationality, z. B. "Nigeria",
 * "Côte d'Ivoire") — keine Datenmigration, keine neue Spalte. Angezeigt wird der Name in der Sprache der
 * App (Intl.DisplayNames mit dem ISO-Code); der gespeicherte Wert bleibt englisch. Export (CSV/PDF), Listen
 * und Gast-Ansicht zeigen weiter den gespeicherten Text.
 *
 * Obere Gruppe: alle 54 afrikanischen Staaten. Darunter "Weitere Länder" (übrige Staaten, auch die vier
 * Landesverbände des Vereinigten Königreichs, weil im Fußball üblich), weil Spieler auch einen europäischen
 * oder anderen Pass haben.
 *
 * Altwerte, die nicht in der Liste stehen (Tippfehler, "Nigeria / England"), gehen nicht verloren:
 * optionsFor() liefert sie als eigenen Eintrag (Gruppe 'current'), bis jemand etwas anderes wählt.
 */

/** [ISO-3166-Code, englischer Name] */
const AFRICA = [
  ['DZ', 'Algeria'], ['AO', 'Angola'], ['BJ', 'Benin'], ['BW', 'Botswana'], ['BF', 'Burkina Faso'],
  ['BI', 'Burundi'], ['CV', 'Cape Verde'], ['CM', 'Cameroon'], ['CF', 'Central African Republic'],
  ['TD', 'Chad'], ['KM', 'Comoros'], ['CG', 'Congo'], ['CD', 'DR Congo'], ['CI', "Côte d'Ivoire"],
  ['DJ', 'Djibouti'], ['EG', 'Egypt'], ['GQ', 'Equatorial Guinea'], ['ER', 'Eritrea'], ['SZ', 'Eswatini'],
  ['ET', 'Ethiopia'], ['GA', 'Gabon'], ['GM', 'Gambia'], ['GH', 'Ghana'], ['GN', 'Guinea'],
  ['GW', 'Guinea-Bissau'], ['KE', 'Kenya'], ['LS', 'Lesotho'], ['LR', 'Liberia'], ['LY', 'Libya'],
  ['MG', 'Madagascar'], ['MW', 'Malawi'], ['ML', 'Mali'], ['MR', 'Mauritania'], ['MU', 'Mauritius'],
  ['MA', 'Morocco'], ['MZ', 'Mozambique'], ['NA', 'Namibia'], ['NE', 'Niger'], ['NG', 'Nigeria'],
  ['RW', 'Rwanda'], ['ST', 'São Tomé and Príncipe'], ['SN', 'Senegal'], ['SC', 'Seychelles'],
  ['SL', 'Sierra Leone'], ['SO', 'Somalia'], ['ZA', 'South Africa'], ['SS', 'South Sudan'], ['SD', 'Sudan'],
  ['TZ', 'Tanzania'], ['TG', 'Togo'], ['TN', 'Tunisia'], ['UG', 'Uganda'], ['ZM', 'Zambia'], ['ZW', 'Zimbabwe'],
];

const OTHER = [
  ['AF', 'Afghanistan'], ['AL', 'Albania'], ['AD', 'Andorra'], ['AG', 'Antigua and Barbuda'], ['AR', 'Argentina'],
  ['AM', 'Armenia'], ['AU', 'Australia'], ['AT', 'Austria'], ['AZ', 'Azerbaijan'], ['BS', 'Bahamas'],
  ['BH', 'Bahrain'], ['BD', 'Bangladesh'], ['BB', 'Barbados'], ['BY', 'Belarus'], ['BE', 'Belgium'],
  ['BZ', 'Belize'], ['BT', 'Bhutan'], ['BO', 'Bolivia'], ['BA', 'Bosnia and Herzegovina'], ['BR', 'Brazil'],
  ['BN', 'Brunei'], ['BG', 'Bulgaria'], ['KH', 'Cambodia'], ['CA', 'Canada'], ['CL', 'Chile'], ['CN', 'China'],
  ['CO', 'Colombia'], ['CR', 'Costa Rica'], ['HR', 'Croatia'], ['CU', 'Cuba'], ['CY', 'Cyprus'],
  ['CZ', 'Czechia'], ['DK', 'Denmark'], ['DM', 'Dominica'], ['DO', 'Dominican Republic'], ['EC', 'Ecuador'],
  ['SV', 'El Salvador'], ['EE', 'Estonia'], ['FJ', 'Fiji'], ['FI', 'Finland'], ['FR', 'France'],
  ['GE', 'Georgia'], ['DE', 'Germany'], ['GR', 'Greece'], ['GD', 'Grenada'], ['GT', 'Guatemala'],
  ['GY', 'Guyana'], ['HT', 'Haiti'], ['HN', 'Honduras'], ['HU', 'Hungary'], ['IS', 'Iceland'], ['IN', 'India'],
  ['ID', 'Indonesia'], ['IR', 'Iran'], ['IQ', 'Iraq'], ['IE', 'Ireland'], ['IL', 'Israel'], ['IT', 'Italy'],
  ['JM', 'Jamaica'], ['JP', 'Japan'], ['JO', 'Jordan'], ['KZ', 'Kazakhstan'], ['KI', 'Kiribati'],
  ['KP', 'North Korea'], ['KR', 'South Korea'], ['XK', 'Kosovo'], ['KW', 'Kuwait'], ['KG', 'Kyrgyzstan'],
  ['LA', 'Laos'], ['LV', 'Latvia'], ['LB', 'Lebanon'], ['LI', 'Liechtenstein'], ['LT', 'Lithuania'],
  ['LU', 'Luxembourg'], ['MY', 'Malaysia'], ['MV', 'Maldives'], ['MT', 'Malta'], ['MH', 'Marshall Islands'],
  ['MX', 'Mexico'], ['FM', 'Micronesia'], ['MD', 'Moldova'], ['MC', 'Monaco'], ['MN', 'Mongolia'],
  ['ME', 'Montenegro'], ['MM', 'Myanmar'], ['NR', 'Nauru'], ['NP', 'Nepal'], ['NL', 'Netherlands'],
  ['NZ', 'New Zealand'], ['NI', 'Nicaragua'], ['MK', 'North Macedonia'], ['NO', 'Norway'], ['OM', 'Oman'],
  ['PK', 'Pakistan'], ['PW', 'Palau'], ['PS', 'Palestine'], ['PA', 'Panama'], ['PG', 'Papua New Guinea'],
  ['PY', 'Paraguay'], ['PE', 'Peru'], ['PH', 'Philippines'], ['PL', 'Poland'], ['PT', 'Portugal'],
  ['QA', 'Qatar'], ['RO', 'Romania'], ['RU', 'Russia'], ['KN', 'Saint Kitts and Nevis'], ['LC', 'Saint Lucia'],
  ['VC', 'Saint Vincent and the Grenadines'], ['WS', 'Samoa'], ['SM', 'San Marino'], ['SA', 'Saudi Arabia'],
  ['RS', 'Serbia'], ['SG', 'Singapore'], ['SK', 'Slovakia'], ['SI', 'Slovenia'], ['SB', 'Solomon Islands'],
  ['ES', 'Spain'], ['LK', 'Sri Lanka'], ['SR', 'Suriname'], ['SE', 'Sweden'], ['CH', 'Switzerland'],
  ['SY', 'Syria'], ['TW', 'Taiwan'], ['TJ', 'Tajikistan'], ['TH', 'Thailand'], ['TL', 'Timor-Leste'],
  ['TO', 'Tonga'], ['TT', 'Trinidad and Tobago'], ['TR', 'Turkey'], ['TM', 'Turkmenistan'], ['TV', 'Tuvalu'],
  ['UA', 'Ukraine'], ['AE', 'United Arab Emirates'], ['GB', 'United Kingdom'], ['US', 'United States'],
  ['UY', 'Uruguay'], ['UZ', 'Uzbekistan'], ['VU', 'Vanuatu'], ['VA', 'Vatican City'], ['VE', 'Venezuela'],
  ['VN', 'Vietnam'], ['YE', 'Yemen'],
];

/* Landesverbände des Vereinigten Königreichs: kein eigener ISO-Regionscode, deshalb eigene Namen. */
const HOME_NATIONS = [
  { code: '', name: 'England', names: { de: 'England', fr: 'Angleterre', es: 'Inglaterra' } },
  { code: '', name: 'Northern Ireland', names: { de: 'Nordirland', fr: 'Irlande du Nord', es: 'Irlanda del Norte' } },
  { code: '', name: 'Scotland', names: { de: 'Schottland', fr: 'Écosse', es: 'Escocia' } },
  { code: '', name: 'Wales', names: { de: 'Wales', fr: 'Pays de Galles', es: 'Gales' } },
];

const toEntry = (group) => ([code, name]) => ({ code, name, group, names: null });

/** Die 54 afrikanischen Staaten. `name` = englischer Name = gespeicherter Wert. */
export const AFRICAN_COUNTRIES = AFRICA.map(toEntry('africa'));
/** Übrige Länder. */
export const OTHER_COUNTRIES = [...OTHER.map(toEntry('other')), ...HOME_NATIONS.map((e) => ({ ...e, group: 'other' }))];
export const ALL_COUNTRIES = [...AFRICAN_COUNTRIES, ...OTHER_COUNTRIES];

/** Gruppen in der Reihenfolge der Anzeige ('current' = Altwert, steht ganz oben, wenn vorhanden). */
export const COUNTRY_GROUPS = ['current', 'africa', 'other'];

const BY_NAME = new Map(ALL_COUNTRIES.map((c) => [c.name.toLowerCase(), c]));

/* Anzeigenamen je Sprache einmal bilden */
const displayCache = new Map();
function displayNamesFor(locale) {
  if (!displayCache.has(locale)) {
    let dn = null;
    try { dn = new Intl.DisplayNames([locale], { type: 'region' }); } catch { /* ältere Umgebung: Englisch */ }
    displayCache.set(locale, dn);
  }
  return displayCache.get(locale);
}

/** Name des Landes in der Sprache `locale` ('en' | 'de' | 'fr' | 'es'); Rückfall: englischer Name. */
export function countryLabel(country, locale = 'en') {
  if (locale === 'en') return country.name;
  if (country.names && country.names[locale]) return country.names[locale];
  if (!country.code) return country.name;
  try {
    const label = displayNamesFor(locale)?.of(country.code);
    return label && label !== country.code ? label : country.name;
  } catch {
    return country.name;
  }
}

/** Suchtext: Kleinbuchstaben, ohne Akzente, ' und ’ gleich, Mehrfach-Leerzeichen zusammengezogen. */
export function normalizeSearch(s) {
  return String(s ?? '')
    .normalize('NFD').replace(/\p{M}/gu, '')
    .toLowerCase()
    .replace(/[’‘`´]/g, "'")
    .replace(/\s+/g, ' ')
    .trim();
}

/** Eintrag zum gespeicherten (englischen) Wert, oder null (leer oder Altwert). */
export function findCountry(value) {
  return BY_NAME.get(String(value ?? '').trim().toLowerCase()) || null;
}

/**
 * Auswahlmöglichkeiten für die Auswahlliste, gruppiert und nach Anzeigename sortiert.
 * Gesucht wird im englischen UND im angezeigten Namen, ohne Akzente ("cote" findet "Côte d'Ivoire").
 * Ein gespeicherter Wert außerhalb der Liste erscheint als eigener Eintrag in der Gruppe 'current'.
 *
 * @returns {Array<{group: string, items: Array<{value: string, label: string, legacy?: boolean}>}>} leere Gruppen fehlen
 */
export function optionsFor({ value = '', query = '', locale = 'en' } = {}) {
  const q = normalizeSearch(query);
  const collator = new Intl.Collator(locale, { sensitivity: 'base' });
  const matches = (label, name) => !q || normalizeSearch(label).includes(q) || normalizeSearch(name).includes(q);

  const groups = [];
  const raw = String(value ?? '').trim();
  if (raw && !findCountry(raw) && matches(raw, raw)) {
    groups.push({ group: 'current', items: [{ value: String(value), label: raw, legacy: true }] });
  }
  for (const group of ['africa', 'other']) {
    const items = ALL_COUNTRIES
      .filter((c) => c.group === group)
      .map((c) => ({ value: c.name, label: countryLabel(c, locale) }))
      .filter((o) => matches(o.label, o.value))
      .sort((a, b) => collator.compare(a.label, b.label));
    if (items.length) groups.push({ group, items });
  }
  return groups;
}

/** Text im geschlossenen Feld: Name in der App-Sprache für bekannte Länder, sonst der gespeicherte Text. */
export function displayValue(value, locale = 'en') {
  const c = findCountry(value);
  return c ? countryLabel(c, locale) : String(value ?? '');
}
